import { render, staticRenderFns } from "./trsShippingPolicy.vue?vue&type=template&id=358815c4&scoped=true"
import script from "./trsShippingPolicy.vue?vue&type=script&lang=js"
export * from "./trsShippingPolicy.vue?vue&type=script&lang=js"
import style0 from "./trsShippingPolicy.vue?vue&type=style&index=0&id=358815c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358815c4",
  null
  
)

export default component.exports